import { render, staticRenderFns } from "./shipment_requests.vue?vue&type=template&id=8105f4f4&"
import script from "./shipment_requests.vue?vue&type=script&lang=js&"
export * from "./shipment_requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports